class DlChristmasFooter2025LL extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initializeElements();
        this.bindEvents();
        this.handleResize();
    }

    disconnectedCallback() {
        this.unbindEvents();
    }

    initializeElements() {
        this.container_pc = this.querySelector('.dl-christmas-footer-2025-ll-container-pc');
        this.container_mobile = this.querySelector('.dl-christmas-footer-2025-ll-container-mobile');
    }

    bindEvents() {
        this.resizeHandler = this.handleResize.bind(this);
        window.addEventListener('resize', this.resizeHandler);
    }

    unbindEvents() {
        window.removeEventListener('resize', this.resizeHandler);
    }

    handleResize() {
        const windowWidth = window.innerWidth;
        const BREAKPOINT = 990;

        if (windowWidth <= BREAKPOINT) {
            // 移动端：隐藏PC，显示Mobile
            if (this.container_pc) this.container_pc.style.display = 'none';
            if (this.container_mobile) this.container_mobile.style.display = 'block';
        }
        else {
            // PC端：显示PC，隐藏Mobile
            if (this.container_pc) this.container_pc.style.display = 'flex';
            if (this.container_mobile) this.container_mobile.style.display = 'none';
        }
    }
}
customElements.define('dl-christmas-footer-2025-ll', DlChristmasFooter2025LL);